<template>
  <div>
    <p>
      {{ $t("SupportPage.ContactUs.weAreHereToSupportYou") }}
    </p>
    <div>
      <p class="mt-8">
        {{ $t("SupportPage.ContactUs.emailUs") }}
        <a
          class="block contact-us_email"
          :href="`mailto:${email}`"
          target="_blank"
        >
          {{ email }}
        </a>
      </p>
      <p class="mt-2">
        {{ $t("SupportPage.ContactUs.orVisitWebsite") }}
        <a
          class="block contact-us_website"
          :href="`https://${website}`"
          target="_blank"
        >
          {{ website }}
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "customersupport@mindmaze.com",
      website: "www.mindmaze.com/contact",
    };
  },
};
</script>
